import script from "./Blacklist.vue?vue&type=script&setup=true&lang=js"
export * from "./Blacklist.vue?vue&type=script&setup=true&lang=js"

import "./Blacklist.vue?vue&type=style&index=0&id=30b7455d&scoped=true&lang=scss"

import exportComponent from "/home/github-runner/actions-runner/_work/acutame/acutame/src/main/front/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b7455d"]])

export default __exports__